// extracted by mini-css-extract-plugin
export var brand = "_30-7";
export var compact = "_30-5";
export var extraSmall = "_30-a";
export var icon = "_30-0";
export var large = "_30-3";
export var light = "_30-1";
export var medium = "_30-4";
export var outline = "_30-9";
export var primaryDark = "_30-8";
export var primaryLight = "_30-6";
export var primaryModern = "_30-b";
export var success = "_30-2";